import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {ReservationDate, ReservationsResponse} from 'models/Reservations';
import {AuthActions} from 'store/auth/auth.reducer';

export interface ReservationState {
  readonly loading: boolean;
  readonly failed: boolean;
  readonly error?: string;
  readonly reservations: ReservationDate[];
}

export const initialState: ReservationState = {
  loading: false,
  failed: false,
  error: undefined,
  reservations: [],
};

const reservationsSlice = createSlice({
  name: 'reservations',
  initialState,
  reducers: {
    clearReservations() {
      return initialState;
    },
    getReservations(state) {
      state.loading = true;
      state.failed = false;
    },
    getReservationsSuccess(
      state,
      {payload}: PayloadAction<ReservationsResponse>
    ) {
      state.loading = false;
      state.failed = false;
      state.reservations = payload.reservations ?? [];
    },
    getReservationsFailed(state) {
      state.loading = false;
      state.failed = true;
      state.reservations = [];
    },
  },
  extraReducers: builder => {
    builder.addCase(AuthActions.logout.type, () => initialState);
  },
});

export const ReservationsActions = reservationsSlice.actions;

const ReservationsReducer = reservationsSlice.reducer;
export default ReservationsReducer;
